import { translate } from '@/utils/i18n/translate.reactive-helpers';
import { Component, output, signal, ChangeDetectionStrategy } from '@angular/core';
import type { TailoredWidgetId } from '../../../interfaces/TailoredWidget.interface';
import {
    type AdvizeoModalButton,
    type AdvizeoModalComponent,
    injectAdvizeoModalInput
} from '../../advizeo-modal-spawner/advizeo-modal-spawner.component';
import { TailoredWidgetEditorComponent, type TailoredWidgetEditorIntent } from '../tailored-widget-editor/tailored-widget-editor';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./tailored-widget-editor-modal.scss'],
    selector: 'tailored-widget-editor-modal',
    templateUrl: 'tailored-widget-editor-modal.html',
    imports: [TailoredWidgetEditorComponent]
})
export class TailoredWidgetEditorModalComponent implements AdvizeoModalComponent<TailoredWidgetEditorIntent, TailoredWidgetId> {
    input = injectAdvizeoModalInput<TailoredWidgetEditorIntent>();
    close = output<TailoredWidgetId | void>();

    isDismissable = signal(true);
    buttons = signal<AdvizeoModalButton[]>([]);

    title = translate('TAILORED_WIDGET.CONFIGURATION_TITLE');

    modalClosureRequested(widgetId?: TailoredWidgetId) {
        this.close.emit(widgetId);
    }
}
